export default __webpack_public_path__ + "static/media/pin-round.131db859.svg";